import { parseMarkdown } from './markdown.utils';
import { ExecutionOutputResponse } from 'src/app/interfaces/execution-output.interface';

/**
 * Format message with proper Markdown line breaks
 * Converts single newlines to Markdown line breaks (two spaces + newline)
 * and keeps double newlines as paragraph breaks
 * @param message - Raw message text with newlines
 * @returns Parsed HTML string with proper line breaks
 */
export function formatMessageWithLineBreaks(message: string): string {
  // Convert single newlines to proper Markdown line breaks (two spaces + newline)
  // and keep double newlines as paragraph breaks
  const markdownText = message
    .replace(/(?<!\n)\n(?!\n)/g, '  \n\n');  // Convert single newlines to Markdown line breaks

  return parseMarkdown(markdownText);
}

/**
 * Render a structured ExecutionOutputResponse from the backend into HTML.
 * Uses pre-parsed logs and artifact descriptors instead of raw [IMAGE] tag parsing.
 * This ensures consistent rendering for both Electron and Browser execution modes.
 * @param response - Backend ExecutionOutputResponse with logs and artifacts
 * @returns HTML string with formatted logs and embedded images
 */
export const renderStructuredResult = (response: ExecutionOutputResponse): string => {
  const logs = response.logs || '';
  const artifacts = response.artifacts || [];

  let html = parseMarkdown(`\`\`\`\n${logs}\n\`\`\``);

  const embeddedImages = artifacts.filter(a => a.type === 'image' && a.embedded && a.base64_data);
  if (embeddedImages.length > 0) {
    const imageHtml = embeddedImages.map(img =>
      `<div class="execution-image-container" style="margin-top: 16px;">
        <img src="${img.base64_data}" width="1000" height="600" style="border: 1px solid #ddd; border-radius: 4px;" alt="${img.filename}" />
      </div>`
    ).join('');
    html += imageHtml;
  }

  return html;
};
